import { c as _c } from "react/compiler-runtime";
import { ThemeVariant } from "@/types";
import { cva } from "class-variance-authority";
import React from "react";
const burgerButtonVariants = cva("rounded-l-full rounded-r-full flex justify-center h-10", {
  variants: {
    variant: {
      dark: "bg-purple-medium/80 backdrop-blur-2xl",
      light: "bg-black/40 backdrop-blur-2xl"
    }
  },
  defaultVariants: {
    variant: "dark"
  }
});
interface BurgerButtonProps {
  variant: ThemeVariant;
  isMenuOpen: boolean;
  onToggle: () => void;
}
export const BurgerButton: React.FC<BurgerButtonProps> = t0 => {
  const $ = _c(14);
  const {
    variant,
    isMenuOpen,
    onToggle
  } = t0;
  let t1;
  if ($[0] !== variant) {
    t1 = burgerButtonVariants({
      variant
    });
    $[0] = variant;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `flex flex-col justify-center items-center relative w-10 h-10 transition-all duration-300 outline-offset-0 focus-visible:outline-2 focus-visible:outline-offset-2 ${variant === "light" ? "outline-yellow" : "outline-purple"} ${t1}`;
  const t3 = `block w-5 h-0.5 bg-white transition-all duration-300 absolute ${isMenuOpen ? "rotate-45" : "-translate-y-1.5"}`;
  let t4;
  if ($[2] !== t3) {
    t4 = <span className={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `block w-5 h-0.5 bg-white transition-all duration-300 ${isMenuOpen ? "hidden" : "block"}`;
  let t6;
  if ($[4] !== t5) {
    t6 = <span className={t5} />;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = `block w-5 h-0.5 bg-white transition-all duration-300 absolute ${isMenuOpen ? "-rotate-45" : "translate-y-1.5"}`;
  let t8;
  if ($[6] !== t7) {
    t8 = <span className={t7} />;
    $[6] = t7;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== onToggle || $[9] !== t2 || $[10] !== t4 || $[11] !== t6 || $[12] !== t8) {
    t9 = <button onClick={onToggle} className={t2} aria-label="Toggle menu">{t4}{t6}{t8}</button>;
    $[8] = onToggle;
    $[9] = t2;
    $[10] = t4;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
};